import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { inject, provideAppInitializer } from '@angular/core';
import { SliderService } from '@uigy/shared/components/slider/services/slider.service';
import { AppInitializationService, init } from '@uigy/shared/services/app-initialization.service';
import { EventsTypesService } from '@uigy/shared/services/eventsTypes.service';

import { PopupService } from '@uigy/shared/services/popup.service';

import { LocalStorageService } from './local-storage.service';
import { restInterceptor } from '@uigy/shared/services/restInterceptor.service';
import { iemInterceptor } from '@uigy/shared/services/iemInterceptor.service';

const HTTP_INTERCEPTORS_PROVIDERS = [
  {
    provide: HTTP_INTERCEPTORS,
    useValue: restInterceptor,
    multi: true
  },
  {
    provide: HTTP_INTERCEPTORS,
    useValue: iemInterceptor,
    multi: true
  },
];

const APP_INITIALIZER_PROVIDERS = [provideAppInitializer(() => {
        const initializerFn = (init)(inject(AppInitializationService));
        return initializerFn();
      })];

export const Services = [
  EventsTypesService,
  APP_INITIALIZER_PROVIDERS,
  HTTP_INTERCEPTORS_PROVIDERS,
  LocalStorageService,
  PopupService,
  SliderService
];
